import formatPrice from './price/format-price';

const mapCartMutationResponse = (rawCart: Cart): Partial<Cart> => ({
    itemsInBundles: rawCart.itemsInBundles,
    loaded: true,
    voucher: rawCart.voucher,
    usedCredits: rawCart.usedCredits,
    originalPrice: parseFloat(rawCart.originalPrice).toFixed(2),
    finalPrice: parseFloat(rawCart.finalPrice).toFixed(2),
    cartItems: rawCart.cartItems.map((item) => ({ ...item, finalPrice: formatPrice(item.finalPrice) })),
    totalVoucherDiscount: rawCart.totalVoucherDiscount ? formatPrice(rawCart.totalVoucherDiscount) : 0,
    voucherError: rawCart.voucherError,
    promo: rawCart.promo
});

export default mapCartMutationResponse;
